// extracted by css-extract-rspack-plugin
export default {"FieldTypeIcon":"SemanticTypePicker-module__FieldTypeIcon___XlZ11","ellipsis":"SemanticTypePicker-module__ellipsis___VpvwS"};